// @ts-nocheck
/* eslint-disable no-unused-vars */
import Select from 'react-select';
// import useGetAccounts from '@hooks/Finance/ChartAccountsDetails/useGetAccounts';
import { useTranslation } from 'react-i18next';
import useGlChartLookups from '@hooks/Finance/ChartAccountsDetails/useGlChartLookups';

export const SelectAccount = ({ value, onChange }) => {
 
  const { OptionsAccounts, loading } = useGlChartLookups();

  const { t, i18n } = useTranslation();

  return (
    <Select
      classNamePrefix='react-select'
      isLoading={loading}
      isSearchable={true}
      isClearable
      options={OptionsAccounts}
      value={OptionsAccounts?.find(f => f.value === value)}
      onChange={onChange}
      placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
    />
  );
};
